import React from "react"
import PropTypes from "prop-types"

import { Text } from "ui"
import WithRecord from "data/wrappers/WithRecord"
import { Link } from "react-router"

class RecordLookup extends React.Component {
    render() {
        return (
            <WithRecord recordId={this.props.recordId}>
                {({ record, primaryField }) => {
                    return (
                        <Link to={"record/" + record._sid}>
                            <Text {...this.props}>{record[primaryField.api_name]}</Text>
                        </Link>
                    )
                }}
            </WithRecord>
        )
    }
}

RecordLookup.propTypes = {
    recordId: PropTypes.string,
}

export default RecordLookup



// WEBPACK FOOTER //
// ./src/features/records/components/RecordLookup.js